import React from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const handleDemoLogin = () => {
    // Create a demo user
    const demoUser = {
      name: "Demo User",
      email: "demo@tastybites.com",
      phone: "+1234567890",
      address: "123 Restaurant Street, Food City"
    };
    
    // Store in localStorage
    localStorage.setItem('user', JSON.stringify(demoUser));
    
    // Navigate to profile
    navigate('/profile');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-5 text-center">
              <h2 className="card-title text-center mb-4">Login to TastyBites</h2>
              
              <p className="mb-4">Demo version - no authentication required</p>
              
              <button 
                className="btn btn-primary w-100 py-2"
                onClick={handleDemoLogin}
              >
                Enter Demo Mode
              </button>
              
              <div className="text-center mt-4">
                <p>This will take you to your profile page</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;